import React, { useEffect, useState, useCallback } from "react";
import { gsap } from "gsap";
import Color from "color";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as ArrowOutward } from "../../Assets/Icons/arrow_outward.svg";
import IntegrateImage from "../../Assets/Images/Websites/02_design.png";
import AutopilotImage from "../../Assets/Images/Websites/04_maintain.png";
import ReviewImage from "../../Assets/Images/Websites/03_develop.png";
import ExpandImage from "../../Assets/Images/Websites/05_scale.png";

import ExtensionIcon from "../../Assets/Icons/extension_24dp.svg";
import AIIcon from "../../Assets/Icons/hotel_class_24dp.svg";
import EditIcon from "../../Assets/Icons/edit_note_24dp.svg";
import SEOIcon from "../../Assets/Icons/query_stats_24dp.svg";

import useTranslationEncapsulated from "../../Libs/useTranslation";
import "./index.scss";

const useGlowPointer = () => {
  const UPDATE = useCallback(({ x, y }) => {
    document.documentElement.style.setProperty("--x", x.toFixed(2));
    document.documentElement.style.setProperty(
      "--xp",
      (x / window.innerWidth).toFixed(2)
    );
    document.documentElement.style.setProperty("--y", y.toFixed(2));
    document.documentElement.style.setProperty(
      "--yp",
      (y / window.innerHeight).toFixed(2)
    );
  }, []);
  useEffect(() => {
    document.body.addEventListener("pointermove", UPDATE);
    return () => {
      document.body.removeEventListener("pointermove", UPDATE);
    };
  }, []);
  return null;
};

export default function GlowCard({
  data,
  options = {
    theme: "dark",
    description: "right",
    title: "left",
  },
  items,
}) {

  const { getTranslatableContent, Trans, getRawKey, t } =
    useTranslationEncapsulated();

  const IMAGES = [IntegrateImage, AutopilotImage, ReviewImage, ExpandImage];
  const SVGS = [ExtensionIcon, AIIcon, EditIcon, SEOIcon];

  const PATHS = [
    "M11.25 5.337c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.036 1.007-1.875 2.25-1.875S15 2.34 15 3.375c0 .369-.128.713-.349 1.003-.215.283-.401.604-.401.959 0 .332.278.598.61.578 1.91-.114 3.79-.342 5.632-.676a.75.75 0 0 1 .878.645 49.17 49.17 0 0 1 .376 5.452.657.657 0 0 1-.66.664c-.354 0-.675-.186-.958-.401a1.647 1.647 0 0 0-1.003-.349c-1.035 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401.31 0 .557.262.534.571a48.774 48.774 0 0 1-.595 4.845.75.75 0 0 1-.61.61c-1.82.317-3.673.533-5.555.642a.58.58 0 0 1-.611-.581c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.035-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959a.641.641 0 0 1-.658.643 49.118 49.118 0 0 1-4.708-.36.75.75 0 0 1-.645-.878c.293-1.614.504-3.257.629-4.924A.53.53 0 0 0 5.337 15c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.036 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.369 0 .713.128 1.003.349.283.215.604.401.959.401a.656.656 0 0 0 .659-.663 47.703 47.703 0 0 0-.31-4.82.75.75 0 0 1 .83-.832c1.343.155 2.703.254 4.077.294a.64.64 0 0 0 .657-.642Z",
    "M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z",
    "M17.303 5.197A7.5 7.5 0 0 0 6.697 15.803a.75.75 0 0 1-1.061 1.061A9 9 0 1 1 21 10.5a.75.75 0 0 1-1.5 0c0-1.92-.732-3.839-2.197-5.303Zm-2.121 2.121a4.5 4.5 0 0 0-6.364 6.364.75.75 0 1 1-1.06 1.06A6 6 0 1 1 18 10.5a.75.75 0 0 1-1.5 0c0-1.153-.44-2.303-1.318-3.182Zm-3.634 1.314a.75.75 0 0 1 .82.311l5.228 7.917a.75.75 0 0 1-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 0 1-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 0 1-1.247-.606l.569-9.47a.75.75 0 0 1 .554-.68Z",
    "M48.75 372.142857 L0 338.571429 L150 110 L240 210 L360 24.2857143 L450 152.857143 L551.25 0 L600 33.5714286 L451.5 257.857143 L362.25 130 L248.25 306.428571 L157.5 205.714286 L48.75 372.142857 Z M405 485.714286 C426 485.714286 443.75 478.809524 458.25 465 C472.75 451.190476 480 434.285714 480 414.285714 C480 394.285714 472.75 377.380952 458.25 363.571429 C443.75 349.761905 426 342.857143 405 342.857143 C384 342.857143 366.25 349.761905 351.75 363.571429 C337.25 377.380952 330 394.285714 330 414.285714 C330 434.285714 337.25 451.190476 351.75 465 C366.25 478.809524 384 485.714286 405 485.714286 Z M558 600 L477 522.857143 C466.5 529.52381 455.125 534.52381 442.875 537.857143 C430.625 541.190476 418 542.857143 405 542.857143 C367.5 542.857143 335.625 530.357143 309.375 505.357143 C283.125 480.357143 270 450 270 414.285714 C270 378.571429 283.125 348.214286 309.375 323.214286 C335.625 298.214286 367.5 285.714286 405 285.714286 C442.5 285.714286 474.375 298.214286 500.625 323.214286 C526.875 348.214286 540 378.571429 540 414.285714 C540 426.666667 538.25 438.690476 534.75 450.357143 C531.25 462.02381 526 472.857143 519 482.857143 L600 560 L558 600 Z",
    "M14.447 3.026a.75.75 0 0 1 .527.921l-4.5 16.5a.75.75 0 0 1-1.448-.394l4.5-16.5a.75.75 0 0 1 .921-.527ZM16.72 6.22a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 1 1-1.06-1.06L21.44 12l-4.72-4.72a.75.75 0 0 1 0-1.06Zm-9.44 0a.75.75 0 0 1 0 1.06L2.56 12l4.72 4.72a.75.75 0 0 1-1.06 1.06L.97 12.53a.75.75 0 0 1 0-1.06l5.25-5.25a.75.75 0 0 1 1.06 0Z",
  ];

  const CONFIG = {
    body: "rgb(40, 40, 40)",
    icon: 0,
    movement: 250,
    explode: false,
    spread: false,
    border: 2,
    radius: 12,
    saturation: 100,
    lightness: 50,
    size: 250,
    card: "rgb(71, 204, 223)",
    cardalpha: 0.1,
    cardblur: 10,
    "bg-spot-opacity": 0.75,
    "border-spot-opacity": 1,
    "border-light-opacity": 1,
  };

  const PHRASES = items.map((i) => i.title);
  const setGlow = useGlowPointer();
  const [cards, setCards] = useState([]);
  const showPaths = false;
  const showSvgs = true;

  const getCardModelData = (i) => {
    return {
      ...i,
      id: crypto.randomUUID(),
      spread: gsap.utils.random(0, 1000),
      outer: true,
      control: true,
      base: gsap.utils.random(0, 359),
    };
  };

  const SYNC_STYLES = () => {
    for (const key of Object.keys(CONFIG)) {
      if (
        key !== "addCard" &&
        key !== "explode" &&
        key !== "card" &&
        key !== "cardalpha"
      ) {
        document.body.style.setProperty(`--${key}`, CONFIG[key]);
      }
      if (key === "card") {
        const hsl = new Color(CONFIG.card).hsl();
        document.body.style.setProperty(
          "--backdrop",
          `hsl(${hsl.color[0]} ${hsl.color[1]}% ${hsl.color[2]}% / ${CONFIG.cardalpha})`
        );
        document.body.style.setProperty(
          "--backup-border",
          `hsl(${hsl.color[0]} ${hsl.color[1]}% ${hsl.color[2]}% / ${Math.max(
            CONFIG.cardalpha,
            0.2
          )})`
        );
      }
    }
  };

  useEffect(() => {
    SYNC_STYLES();
    if (items.length) {
      setCards([...items.map((i) => getCardModelData(i))]);
    }
  }, [items]);

  useEffect(() => {
    if (cards?.length) {
    }
  }, [cards]);

  return (
    <>
      {cards?.length
        ? cards?.map((card, index) => {
            return (
              <>
                <article
                  className="card"
                  data-glow
                  style={{
                    "--base": card.base,
                    "--spread": card.spread,
                  }}
                >
                  {card.outer ? <div data-glow></div> : null}
                  <div className="card__content">
                    <span data-glow>{card.label}</span>
                    <div>
                      {showPaths ? (
                        <>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="none"
                            dataSlot="icon"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d={PATHS[index]}
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="none"
                            dataSlot="icon"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d={PATHS[index]}
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="none"
                            dataSlot="icon"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d={PATHS[index]}
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="none"
                            dataSlot="icon"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d={PATHS[index]}
                            />
                          </svg>
                        </>
                      ) : (
                        <>
                          <img src={showSvgs ? SVGS[index] : IMAGES[index]} />
                          <img src={showSvgs ? SVGS[index] : IMAGES[index]} />
                          <img src={showSvgs ? SVGS[index] : IMAGES[index]} />
                          <img src={showSvgs ? SVGS[index] : IMAGES[index]} />
                        </>
                      )}
                    </div>
                    <h2 dangerouslySetInnerHTML={{ __html: PHRASES[index] }} />
                  </div>
                  <Link
                    className="hero-text-tout-with-list__content-list__item-link"
                    to={card.link}
                  >
                    <span className="label">
                      {card.linkText}
                    </span>
                    <span className="icon">
                      <ArrowOutward />
                    </span>
                  </Link>
                </article>
              </>
            );
          })
        : null}
    </>
  );
}
